import { render, staticRenderFns } from "./CustomerFormMain.vue?vue&type=template&id=0fe37b9a&"
import script from "./CustomerFormMain.vue?vue&type=script&lang=js&"
export * from "./CustomerFormMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports